// =====================================================================
// SITE CONFIGURATION — edit this file to add real contact details.
// Leave a value as "" and the site shows a neutral "coming soon" state.
// =====================================================================

export const SITE = {
  brand: "VION Tech",
  legalName: "VION Technology Limited",
  tagline: "AI. Technology. Education. Global Opportunities.",
  slogan: "Learn. Innovate. Transform.",
  url: "https://viontechnology.com",

  contact: {
    // TODO: public enquiries email, e.g. "hello@yourdomain.com"
    email: "viontechhub@gmail.com",
    // TODO: WhatsApp number in international format, digits only, e.g. "2348000000000"
    whatsapp: "2347030983150",
    // TODO: full LinkedIn company page URL
    linkedin: "https://www.linkedin.com/company/vion-technologyltd",
    // TODO: full Facebook page URL
    facebook: "https://web.facebook.com/profile.php?id=100088659107911",
  },
};

export const channels = () => {
  const c = SITE.contact;
  return [
    { key: "whatsapp", label: "WhatsApp", value: c.whatsapp ? `+${c.whatsapp}` : "", href: c.whatsapp ? `https://wa.me/${c.whatsapp}` : "" },
    { key: "email", label: "Email", value: c.email, href: c.email ? `mailto:${c.email}` : "" },
    { key: "linkedin", label: "LinkedIn", value: c.linkedin ? "Company page" : "", href: c.linkedin },
    { key: "facebook", label: "Facebook", value: c.facebook ? "Facebook page" : "", href: c.facebook },
  ];
};
